import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41dec2b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-container" }
const _hoisted_2 = {
  class: "editable-content-wrapper",
  ref: "scrollContainer"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("p", null, "※ 수요조사는 1인 1신청이 가능합니다."),
  /*#__PURE__*/_createElementVNode("p", null, "※ 구성원의 실제 근무형태가 아닌 신청은 취합 과정에서 제외됩니다.")
], -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-space" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode($setup["VocEditGuideMessage"], {
          class: "guide-message-container",
          htmlText: "(<span class='emphasis'> * </span>)는 필수 입력 사항입니다."
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filters, (filter) => {
          return (_openBlock(), _createBlock($setup["DynamicSurveyField"], {
            class: "filter-wrapper",
            key: filter.key,
            filter: filter,
            value: $setup.getValue(filter) ?? '',
            disabled: $setup.isDisabledFilter(filter),
            onOnSelectOption: $setup.updateData,
            onOnUpdateValue: $setup.onUpdateValue
          }, null, 8 /* PROPS */, ["filter", "value", "disabled", "onOnSelectOption"]))
        }), 128 /* KEYED_FRAGMENT */)),
        _hoisted_3
      ], 512 /* NEED_PATCH */),
      _hoisted_4,
      _createVNode($setup["FooterButton"], {
        title: $setup.footerBtnTitle,
        disabled: $setup.footerBtnDisabled,
        onOnClickFooterButton: $setup.emitOnClickApplyBtn
      }, null, 8 /* PROPS */, ["title", "disabled"])
    ]),
    ($setup.scrollContainer)
      ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
          key: 0,
          container: $setup.scrollContainer,
          style: { bottom: '80px' }
        }, null, 8 /* PROPS */, ["container"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}